export class Associacao {

    inicio: any;

    fim: any;

    carteira: any;

    carteiraId: number;

    regra: any;

    regraId: number;

    processamentoOnlineAtivo: boolean;
}
